import { AddressInputNew } from "../../../components/AddressInputNew";

export const formFields = {
  address: "address",
};
export const templateArea = {
  [formFields.address]: "",
};
export const AreasConfig = [
  {
    id: 3,
    name: formFields.address,
    label: "label:address",
    flexBasis: "100%",
    placeholder: "placeholder:address",
    rules: {
      required: true,
    },
    input: (props) => <AddressInputNew {...props} />,
  },
];
